// Canadian French. Translations are a first pass and should be reviewed by
// a fluent speaker before release.
export const fr = {
    "app.name": "{app}",
    "app.tagline": "Sachez dans quelle saison vous êtes. Préparez les suivantes.",
    "nav.main": "Navigation principale",
    "nav.skip": "Passer au contenu principal",
    "nav.dashboard": "Tableau de bord",
    "nav.budgets": "Budgets",
    "nav.import": "Importer",
    "nav.transactions": "Transactions",
    "tx.empty": "Aucune transaction pour l'instant.",
    "tx.goImport": "Importer un fichier CSV bancaire",
    "tx.filters": "Filtres",
    "tx.month": "Mois",
    "tx.allMonths": "Tous les mois",
    "tx.account": "Compte",
    "tx.allAccounts": "Tous les comptes",
    "tx.search": "Rechercher dans les descriptions",
    "tx.reviewOnly": "Seulement celles sans catégorie ({count})",
    "tx.count": "{count} transactions",
    "tx.allSorted": "Toutes les transactions ont une catégorie.",
    "tx.noMatch": "Aucune transaction ne correspond à ces filtres.",
    "tx.bulkLabel": "Modifier plusieurs à la fois",
    "tx.selected": "{count} sélectionnées",
    "tx.bulkCategory": "Catégorie des transactions sélectionnées",
    "tx.bulkPick": "Choisir une catégorie",
    "tx.bulkApply": "Appliquer à {count}",
    "tx.bulkDone": "{count} transactions classées dans {category}.",
    "tx.selectAll": "Tout sélectionner",
    "tx.select": "Sélectionner {description}",
    "tx.showMore": "Afficher {count} de plus",
    "tx.learnHint": "Quand vous choisissez une catégorie, les prochains imports du même bénéficiaire la reçoivent aussi.",
    "tx.waiting": "{count} transactions n'ont pas de catégorie et ne comptent encore dans aucune ligne du budget.",
    "tx.review": "Les classer maintenant",
    "nav.events": "Événements",
    "events.add": "Ajouter un événement",
    "events.edit": "Modifier l’événement",
    "events.addOn": "Ajouter un événement le {date}",
    "events.saved": "{title} enregistré.",
    "events.deleted": "{title} supprimé.",
    "events.confirmDelete": "Supprimer « {title} »? Toutes ses répétitions seront aussi supprimées.",
    "events.upcoming": "À venir",
    "events.none": "Aucun événement pour l’instant. Ajoutez factures, renouvellements ou anniversaires pour les voir ici et dans votre calendrier.",
    "events.nothingSoon": "Rien dans les {days} prochains jours.",
    "events.next30": "Coûts prévus dans les 30 prochains jours : {amount}",
    "events.repeat": "Répétition",
    "events.repeat.none": "Ne se répète pas",
    "events.repeat.weekly": "Chaque semaine",
    "events.repeat.biweekly": "Toutes les deux semaines",
    "events.repeat.monthly": "Chaque mois",
    "events.repeat.yearly": "Chaque année",
    "events.editShort": "Modifier",
    "events.editNamed": "Modifier {title}",
    "events.delete": "Supprimer l’événement",
    "events.prevMonth": "Mois précédent",
    "events.nextMonth": "Mois suivant",
    "events.keys": "Les flèches déplacent d’un jour ou d’une semaine, Page précédente et Page suivante d’un mois. Entrée ajoute un événement au jour choisi.",
    "events.dayNone": "Aucun événement",
    "events.dayCount": "{count} événement(s)",
    "events.title": "Titre",
    "events.date": "Date",
    "events.until": "Dernière date (facultatif)",
    "events.amount": "Coût prévu (facultatif)",
    "events.category": "Catégorie budgétaire (facultatif)",
    "events.noCategory": "Aucune",
    "events.notes": "Notes (ne quittent jamais cet appareil sans chiffrement)",
    "events.hidden": "Garder hors du serveur (flux de calendrier et rappels sur téléphone)",
    "events.err.title": "Donnez un titre à l’événement.",
    "events.err.date": "Choisissez une date.",
    "events.err.until": "La dernière date ne peut pas précéder la première.",
    "events.err.amount": "Entrez le coût en chiffres, par exemple 85,50.",
    "feed.title": "Flux de calendrier",
    "feed.name": "Événements {app}",
    "feed.intro": "Abonnez-vous à vos événements depuis Google Agenda, Outlook ou Calendrier d’Apple grâce à une adresse privée.",
    "feed.privacy": "Désactivé tant que vous ne l’activez pas. Une fois activé, le serveur garde une copie lisible du titre, de la date et de la répétition de chaque événement (et du montant, si vous le choisissez) pour que votre application de calendrier puisse la lire. Les notes, les catégories et les événements exclus restent chiffrés. Toute personne qui a l’adresse peut lire le flux : traitez-la comme un mot de passe.",
    "feed.detail": "Chaque entrée du calendrier affiche",
    "feed.detail.title": "Le titre seulement",
    "feed.detail.amount": "Le titre et le coût prévu",
    "feed.start": "Activer le flux de calendrier",
    "feed.started": "Le flux de calendrier est activé.",
    "feed.address": "Adresse privée du flux",
    "feed.copy": "Copier l’adresse",
    "feed.copied": "Adresse copiée.",
    "feed.howTo": "Google Agenda : Autres agendas, puis À partir de l’URL. Outlook : Ajouter un calendrier, puis S’abonner à partir du web. Les applications vérifient les changements toutes les quelques heures.",
    "feed.reachable": "Google et Outlook lisent le flux depuis Internet : cette adresse doit donc être accessible hors de votre réseau domestique, par exemple avec l’option Cloudflare Tunnel.",
    "feed.demo": "Mode démo : cette adresse est fictive et rien n’est publié.",
    "feed.newAddress": "Obtenir une nouvelle adresse",
    "feed.confirmNew": "Obtenir une nouvelle adresse? L’adresse actuelle cessera de fonctionner et vous devrez vous réabonner dans vos applications de calendrier.",
    "feed.renewed": "Nouvelle adresse prête. L’ancienne ne fonctionne plus.",
    "feed.stop": "Désactiver",
    "feed.stopped": "Le flux de calendrier est désactivé et sa copie sur le serveur est supprimée.",
    "dash.comingUp": "À venir",
    "dash.comingUpNone": "Rien dans les deux prochaines semaines.",
    "dash.allEvents": "Tous les événements",
    "nav.settings": "Paramètres",
    "auth.signIn": "Se connecter",
    "auth.demo": "Essayer la démo",
    "auth.demoNote": "La démo utilise un ménage fictif et ne conserve rien.",
    "auth.signOut": "Se déconnecter",
    "auth.lock": "Verrouiller",
    "auth.signedOut": "Connectez-vous à votre compte {app} pour continuer.",
    "unlock.title": "Déverrouiller {app}",
    "unlock.intro": "Vos données sont chiffrées. Entrez votre phrase de passe pour les déverrouiller sur cet appareil.",
    "unlock.passphrase": "Phrase de passe",
    "unlock.submit": "Déverrouiller",
    "unlock.working": "Déverrouillage…",
    "unlock.wrong": "Cela n'a pas fonctionné. Vérifiez et réessayez, ou utilisez votre clé de récupération.",
    "unlock.useRecovery": "Utiliser plutôt ma clé de récupération",
    "unlock.usePassphrase": "Utiliser plutôt ma phrase de passe",
    "unlock.recoveryKey": "Clé de récupération",
    "setup.title": "Créez votre phrase de passe",
    "setup.intro": "Vos données sont chiffrées dans ce navigateur avec une clé que seule votre phrase de passe peut déverrouiller. Personne d'autre ne peut les lire, y compris la personne qui gère le serveur.",
    "setup.passphrase": "Phrase de passe",
    "setup.confirm": "Confirmez la phrase de passe",
    "setup.hint": "Au moins 12 caractères. Quelques mots sans lien entre eux font très bien l'affaire.",
    "setup.tooShort": "Utilisez au moins 12 caractères.",
    "setup.mismatch": "Les deux phrases de passe ne correspondent pas.",
    "setup.create": "Créer mes clés de chiffrement",
    "setup.working": "Création des clés…",
    "setup.recoveryTitle": "Conservez votre clé de récupération",
    "setup.recoveryIntro": "Si vous oubliez votre phrase de passe, cette clé est le seul moyen de récupérer l'accès. Imprimez-la ou gardez-la dans un gestionnaire de mots de passe. Elle ne sera plus affichée.",
    "setup.recoveryConfirm": "J'ai conservé ma clé de récupération",
    "setup.copy": "Copier",
    "setup.copied": "Copié",
    "dashboard.title": "Tableau de bord",
    "kpi.label": "Chiffres clés",
    "kpi.cashAvailable": "Reste à dépenser ce mois-ci",
    "kpi.spentToday": "Dépensé aujourd'hui",
    "kpi.monthToDate": "Dépensé ce mois-ci",
    "kpi.netThisMonth": "Solde net du mois",
    "kpi.ofBudget": "sur {budget}",
    "kpi.dailyBudget": "budget quotidien {budget}",
    "status.title": "État du budget",
    "status.day": "Aujourd'hui",
    "status.week": "Cette semaine",
    "status.month": "Ce mois-ci",
    "status.green": "Dans les temps",
    "status.amber": "Près du budget",
    "status.red": "Budget dépassé",
    "status.detail": "{spent} dépensé, {paced} prévu jusqu'ici",
    "pie.title": "Principales catégories du mois",
    "pie.other": "Petites catégories",
    "pie.empty": "Aucune dépense ce mois-ci pour l'instant.",
    "pie.summary": "Catégorie la plus importante : {name}, {amount} ({percent}).",
    "calendar.title": "L'année en un coup d'œil",
    "calendar.metric": "Afficher",
    "calendar.metric.net": "Flux de trésorerie net",
    "calendar.metric.budget": "Dépenses par rapport au budget quotidien",
    "calendar.view": "Vue",
    "calendar.view3d": "3D",
    "calendar.view2d": "Grille",
    "calendar.reset": "Réinitialiser la vue",
    "calendar.instructions": "Les flèches passent d'un jour à l'autre. Page précédente et Page suivante changent de mois. Début et Fin vont au premier et au dernier jour.",
    "calendar.dragHint": "Faites glisser pour pivoter, défilez pour zoomer.",
    "calendar.noTransactions": "aucune transaction",
    "calendar.capped": "Les barres sont plafonnées à {cap}; les jours plus élevés sont marqués d'un point.",
    "calendar.summary": "{up} jours en hausse, {down} jours en baisse. Jour le plus important : {date}, {value}.",
    "calendar.selected": "{date} : {value}",
    "calendar.top": "Principales transactions",
    "budgets.title": "Budgets",
    "budgets.pool": "Enveloppe mensuelle",
    "budgets.poolHelp": "Revenu net moins les engagements fixes. Tous les curseurs se partagent ce montant.",
    "budgets.units": "Afficher chaque ligne en",
    "budgets.mode": "Quand un budget change, ajuster les autres",
    "budgets.modeEqual": "Également",
    "budgets.modeProportional": "Selon leur taille",
    "budgets.period": "Période",
    "budgets.lock": "Verrouiller {name}",
    "budgets.unlock": "Déverrouiller {name}",
    "budgets.budget": "Budget",
    "budgets.actual": "Réel",
    "budgets.left": "Il reste {amount}",
    "budgets.over": "Dépassement de {amount}",
    "budgets.sliderLabel": "Budget {name}",
    "budgets.sliderValue": "{amount}, {percent} de l'enveloppe. Réel jusqu'ici : {actual}.",
    "budgets.rebalanced": "{name} réglé à {amount}. Les autres budgets déverrouillés ont été ajustés.",
    "budgets.help": "Cliquez sur un montant pour saisir un chiffre exact. Les flèches changent un budget de 1 $, Page précédente et Page suivante de 50 $, et la barre d'espace le verrouille ou le déverrouille. Le sélecteur $ / % choisit l'affichage de chaque ligne, et le verrou retient la valeur affichée.",
    "budgets.total": "Total budgété",
    "period.day": "Quotidien",
    "period.week": "Hebdomadaire",
    "period.month": "Mensuel",
    "period.year": "Annuel",
    "import.title": "Importer",
    "import.intro": "Téléchargez un fichier CSV depuis le site de votre banque, puis déposez-le ici.",
    "import.drop": "Déposez un fichier CSV bancaire ici",
    "import.choose": "Choisir un fichier",
    "import.privacy": "Le fichier est lu dans ce navigateur. Seuls des résultats chiffrés sont envoyés au serveur.",
    "import.detected": "Reconnu comme {bank}.",
    "import.unverified": "Ce format de {bank} n'a pas encore été vérifié avec une vraie exportation; examinez bien l'aperçu.",
    "import.unknown": "Le format de ce fichier n'a pas été reconnu. Indiquez à {app} quelles colonnes utiliser.",
    "import.mapDate": "Colonne de la date",
    "import.mapDescription": "Colonne de la description",
    "import.mapAmount": "Colonne du montant",
    "import.mapDateOrder": "Ordre de la date",
    "import.mapApply": "Utiliser ces colonnes",
    "import.account": "Nom du compte",
    "import.summary": "{count} transactions trouvées : {fresh} nouvelles, {duplicates} déjà importées, {errors} lignes illisibles.",
    "import.confirm": "Importer {count} nouvelles transactions",
    "import.done": "{count} transactions importées.",
    "import.duplicate": "Déjà importée",
    "import.needsCategory": "Catégorie à choisir",
    "import.error": "Ligne {line} : {message}",
    "import.col.date": "Date",
    "import.col.description": "Description",
    "import.col.amount": "Montant",
    "import.col.category": "Catégorie",
    "import.col.status": "État",
    "import.new": "Nouvelle",
    "settings.title": "Paramètres",
    "settings.appearance": "Apparence",
    "settings.mode": "Mode",
    "settings.palette": "Palette",
    "settings.language": "Langue",
    "settings.data": "Vos données",
    "settings.export": "Télécharger une copie déchiffrée (JSON)",
    "settings.demoReset": "Réinitialiser le ménage de démonstration",
    "settings.about": "À propos",
    "settings.license": "{app} est un logiciel libre distribué sous la Licence publique générale GNU Affero, version 3 ou ultérieure.",
    "settings.version": "Version {version}",
    "mode.light": "Clair",
    "mode.grey": "Gris",
    "mode.dark": "Sombre",
    "mode.system": "Selon le système",
    "mode.toggle": "Mode : {mode}. Sélectionnez pour changer.",
    "palette.default": "Par défaut (sarcelle et corail)",
    "palette.ocean": "Océan (bleu et orange)",
    "palette.forest": "Forêt (vert et magenta)",
    "palette.colorblind": "Adaptée au daltonisme",
    "palette.contrast": "Contraste élevé",
    "cat.housing": "Logement",
    "cat.groceries": "Épicerie",
    "cat.dining": "Restaurants",
    "cat.transport": "Transport",
    "cat.shopping": "Magasinage",
    "cat.entertainment": "Divertissement",
    "cat.health": "Santé",
    "cat.household": "Maison",
    "cat.savings": "Épargne",
    "cat.other": "Autre",
    "cat.housing/mortgage": "Paiement hypothécaire",
    "cat.housing/mortgage/interest": "Intérêts hypothécaires",
    "cat.housing/property-tax": "Impôt foncier",
    "cat.housing/home-insurance": "Assurance habitation",
    "cat.housing/condo-fees": "Frais de copropriété",
    "cat.housing/upkeep": "Entretien",
    "cat.housing/repairs": "Réparations",
    "cat.housing/rent": "Loyer",
    "cat.housing/tenant-insurance": "Assurance locataire",
    "cat.housing/parking": "Stationnement",
    "cat.housing/utilities": "Services publics",
    "cat.housing/utilities/electricity": "Électricité",
    "cat.housing/utilities/gas": "Gaz naturel",
    "cat.housing/utilities/water": "Eau et égouts",
    "cat.housing/utilities/internet": "Internet",
    "cat.housing/utilities/phone": "Téléphone",
    "cat.transport/loan": "Paiement de prêt ou de location",
    "cat.transport/loan/interest": "Intérêts de financement",
    "cat.transport/maintenance": "Entretien",
    "cat.transport/repairs": "Réparations",
    "cat.transport/insurance": "Assurance",
    "cat.transport/licensing": "Permis et immatriculation",
    "cat.transport/fuel": "Carburant ou recharge",
    "cat.transport/parking": "Stationnement et péages",
    "cat.transport/transit": "Transport en commun",
    "cat.transport/rideshare": "Covoiturage et taxi",
    "cat.dining/restaurants": "Restaurants",
    "cat.dining/coffee": "Café",
    "cat.dining/takeout": "Mets à emporter et livraison",
    "cat.health/prescriptions": "Médicaments",
    "cat.health/dental": "Soins dentaires",
    "cat.health/vision": "Soins de la vue",
    "cat.health/fitness": "Mise en forme",
    "cat.shopping/clothing": "Vêtements",
    "cat.shopping/electronics": "Électronique",
    "cat.shopping/gifts": "Cadeaux",
    "cat.household/furniture": "Meubles",
    "cat.household/supplies": "Fournitures",
    "cat.household/pets": "Animaux",
    "cat.entertainment/subscriptions": "Abonnements",
    "cat.entertainment/events": "Sorties et spectacles",
    "cat.entertainment/hobbies": "Loisirs",
    "budgets.subs": "Sous-catégories de {name}",
    "budgets.subsHelp": "Elles se partagent les {amount} de {name}. En déplacer une rééquilibre les autres; le total reste le même.",
    "budgets.rest": "Le reste de {name}",
    "budgets.addSub": "Nouvelle sous-catégorie de {name}",
    "budgets.addUnder": "Emplacement de la nouvelle sous-catégorie",
    "budgets.under": "Sous {name}",
    "budgets.fromRecent": "Répartir selon les dépenses des 3 derniers mois",
    "budgets.fromRecentDone": "{name} réparti selon les dépenses récentes.",
    "budgets.addSubButton": "Ajouter",
    "budgets.added": "{name} ajouté sous {parent}.",
    "budgets.removeSub": "Retirer {name}",
    "budgets.confirmRemove": "Retirer « {name} »? Ses transactions et son budget passent à {parent}.",
    "budgets.removed": "{name} retiré. Ses transactions sont maintenant sous {parent}.",
    "budgets.nameTaken": "Une catégorie porte déjà ce nom ici.",
    "survey.title": "Configurer vos catégories",
    "survey.intro": "Trois questions rapides pour que votre budget commence avec des catégories qui vous conviennent. Passez celles que vous voulez; vous pourrez les modifier plus tard dans les paramètres.",
    "survey.housing": "Votre logement",
    "survey.housing.own": "Je suis propriétaire",
    "survey.housing.rent": "Je suis locataire",
    "survey.housing.family": "J’habite avec ma famille (aucuns frais de logement)",
    "survey.vehicle": "Véhicules",
    "survey.vehicle.none": "Aucun véhicule",
    "survey.vehicle.owned": "Payé comptant",
    "survey.vehicle.financed": "Financé (prêt)",
    "survey.vehicle.leased": "Loué",
    "survey.pay": "Salaire net (facultatif)",
    "survey.payAmount": "Montant par paie",
    "survey.payFrequency": "Fréquence",
    "survey.pay.weekly": "Chaque semaine",
    "survey.pay.biweekly": "Toutes les deux semaines",
    "survey.pay.semimonthly": "Deux fois par mois",
    "survey.pay.monthly": "Une fois par mois",
    "survey.payHint": "Fixe votre enveloppe budgétaire mensuelle à environ {amount}.",
    "survey.save": "Enregistrer et continuer",
    "survey.skip": "Passer pour l’instant",
    "survey.saved": "Catégories configurées.",
    "survey.payInvalid": "Entrez le montant en chiffres, par exemple 2450.",
    "settings.household": "Configuration du ménage",
    "settings.householdHint": "Vos réponses déterminent les catégories affichées. Les catégories déjà utilisées restent toujours.",
    "update.ready": "Une nouvelle version de {app} est prête.",
    "update.reload": "Recharger maintenant",
    "update.later": "Plus tard",
    "cat.income": "Revenus",
    "cat.transfers-in": "Virements reçus",
    "cat.uncategorized": "Sans catégorie",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.close": "Fermer",
    "common.loading": "Chargement…",
    "common.error": "Un problème est survenu : {message}",
    "auth.failed": "La connexion n'a pas abouti. Réessayez, ou demandez à la personne qui gère ce serveur {app} de vérifier les réglages d'Authentik.",
    "auth.expired": "La connexion a pris trop de temps et a expiré. Réessayez.",
    "auth.offline": "Le serveur {app} est injoignable pour l'instant. Vous pouvez quand même essayer la démo.",
    "auth.signedInAs": "Connecté·e en tant que {name}",
    "import.sample": "Ou essayez un fichier d'exemple fictif :",
    "import.hasHeader": "La première ligne contient le nom des colonnes",
    "palette.custom": "Couleurs personnalisées",
    "settings.customHint": "Choisir la couleur du budget ou des hausses règle aussi sa couleur complémentaire, que vous pouvez ensuite modifier.",
    "settings.color.positive": "Jours en hausse (entrées)",
    "settings.color.negative": "Jours en baisse (sorties)",
    "settings.color.budget": "Budget (haut de chaque curseur)",
    "settings.color.actual": "Réel (bas de chaque curseur)",
    "settings.deleteLabel": "Pour supprimer votre compte, tapez DELETE",
    "settings.deleteHint": "Votre compte et tous vos enregistrements sont supprimés immédiatement. C'est irréversible.",
    "settings.delete": "Supprimer mon compte et mes données",
    "common.saving": "Enregistrement…",
    "common.demoBanner": "Mode démo : données fictives, rien n'est enregistré.",
    "nav.year": "Année",
    "pie.open": "Afficher les sous-catégories de {name}",
    "pie.back": "Retour à {name}",
    "pie.all": "toutes les catégories",
    "dash.period": "Période",
    "dash.prevMonth": "Mois précédent",
    "dash.nextMonth": "Mois suivant",
    "dash.thisMonth": "Ce mois-ci",
    "dash.view": "Afficher",
    "dash.view.month": "Un mois",
    "dash.view.outlook": "Aperçu sur 3 mois",
    "dash.bigPicture": "Vue d'ensemble",
    "dash.today": "Aujourd'hui",
    "dash.yearSoFar": "{year} jusqu'ici",
    "dash.emptyDay": "Aucune dépense aujourd'hui.",
    "dash.emptyMonth": "Aucune dépense en {month}.",
    "dash.emptyYear": "Aucune dépense en {year}.",
    "dash.wholeYear": "Voir toute l'année",
    "dash.outlook": "Aperçu sur 3 mois",
    "dash.budget": "Budget",
    "dash.spent": "Dépensé",
    "dash.scheduled": "Événements prévus",
    "dash.left": "Reste",
    "dash.over": "Dépassement de",
    "dash.planned": "Pas encore commencé : voici le budget prévu.",
    "year.choose": "Année",
    "year.previous": "Année précédente",
    "year.next": "Année suivante",
    "year.thisYear": "Cette année",
    "year.donut": "Dépenses en {year}",
    "year.byCategory": "Par catégorie",
    "year.table": "Mois par mois",
    "year.tableHint": "Chaque mois est comparé à votre budget actuel.",
    "year.category": "Catégorie",
    "year.all": "Toutes les dépenses",
    "year.caption": "{name}, budget et dépenses par mois en {year}",
    "year.month": "Mois",
    "year.notYet": "Pas encore",
    "year.over": "{amount} de trop",
    "year.total": "Total ({count} mois)",
    "kpi.ofBudgetScheduled": "sur {budget}, après {scheduled} d'événements prévus",
    "budgets.scheduled": "Prévu",
    "budgets.sliderScheduled": "Événements prévus {amount}.",
    "events.paid": "Payé le {date}",
    "events.categoryHint": "Le coût compte dans le budget de cette catégorie (ou Autre, sans catégorie) jusqu'à ce qu'un paiement correspondant apparaisse dans vos transactions.",
    "push.when.today": "aujourd'hui",
    "push.when.tomorrow": "demain",
    "push.when.days": "dans {days} jours",
    "push.reminders": "{count} rappel(s) {when}.",
    "push.remindersNamed": "À venir {when} : {list}.",
    "push.more": "et {count} de plus",
    "push.test": "Test de {app} : les notifications sur téléphone fonctionnent.",
    "nav.notifications": "Notifications",
    "notify.unread": ", {count} nouvelle(s)",
    "notify.now": "À traiter",
    "notify.none": "Rien ne demande votre attention pour l'instant.",
    "notify.dismiss": "Masquer",
    "notify.dismissNamed": "Masquer : {text}",
    "notify.dismissAll": "Tout masquer",
    "notify.dismissed": "Masquée.",
    "notify.dismissedAll": "Toutes les notifications sont masquées.",
    "notify.attention": "Attention :",
    "notify.type.bills": "Factures et événements",
    "notify.type.bills.hint": "factures impayées de la semaine à venir, et événements aujourd'hui ou demain",
    "notify.type.budgets": "Budgets",
    "notify.type.budgets.hint": "une catégorie dépassée, ou utilisée à 90 % (dépensé ou prévu)",
    "notify.show": "Quoi afficher",
    "notify.billDue": "{title} : {amount} à payer le {date}.",
    "notify.billOverdue": "{title} : {amount} était dû le {date} et aucun paiement correspondant n'apparaît encore.",
    "notify.eventToday": "{title}, c'est aujourd'hui.",
    "notify.eventTomorrow": "{title}, c'est demain.",
    "notify.budgetOver": "{name} dépasse le budget : {used} sur {budget} dépensé ou prévu ce mois-ci.",
    "notify.budgetNear": "{name} est presque épuisé : {used} sur {budget} dépensé ou prévu ce mois-ci.",
    "push.title": "Notifications sur téléphone (ntfy)",
    "push.intro": "Recevez des rappels sur votre téléphone par votre propre serveur ntfy : un message par jour sur les événements à venir, et une alerte quand un budget est dépassé.",
    "push.privacy": "En activant cette option, le serveur peut lire ce qu'il faut pour les envoyer : les dates de vos événements (sauf ceux gardés hors du serveur) et, si vous le permettez ci-dessous, leurs titres et montants. Les alertes de budget sont calculées sur cet appareil et envoyées seulement avec le niveau de détail choisi.",
    "push.server": "Adresse du serveur ntfy",
    "push.serverHint": "Votre propre serveur ntfy, ou https://ntfy.sh.",
    "push.topic": "Sujet",
    "push.topicHint": "Abonnez-vous à ce sujet dans l'application ntfy. Sur un serveur public, toute personne qui connaît le sujet peut le lire : gardez le sujet aléatoire ou utilisez un jeton d'accès.",
    "push.token": "Jeton d'accès (facultatif)",
    "push.tokenHint": "Nécessaire si votre serveur ntfy exige une connexion. Il est conservé chiffré et n'est plus jamais affiché.",
    "push.tokenKept": "Enregistré; laissez vide pour le garder",
    "push.tokenRemove": "Retirer le jeton enregistré",
    "push.tokenRemoving": "Le jeton sera retiré à l'enregistrement",
    "push.detail": "Ce que les notifications peuvent dire",
    "push.detail.generic": "Seulement des nombres, comme « 2 rappels demain » (le plus privé)",
    "push.detail.titles": "Titres des événements et noms des budgets",
    "push.detail.amounts": "Titres et montants",
    "push.remindHour": "Rappel quotidien à",
    "push.leadDays": "Rappeler les événements",
    "push.lead.same": "le jour même",
    "push.lead.days": "{count} jour(s) d'avance",
    "push.quiet": "Heures de silence (les alertes attendent la fin)",
    "push.quietStart": "De",
    "push.quietEnd": "À",
    "push.digest": "Garder les alertes pour le rappel quotidien au lieu de les envoyer tout de suite",
    "push.timeZone": "Les heures sont dans le fuseau {zone}, celui de cet appareil.",
    "push.start": "Activer les notifications sur téléphone",
    "push.save": "Enregistrer",
    "push.started": "Les notifications sur téléphone sont activées.",
    "push.saved": "Enregistré.",
    "push.sendTest": "Envoyer un test",
    "push.testSent": "Test envoyé. Vérifiez votre téléphone.",
    "push.stop": "Désactiver",
    "push.stopped": "Les notifications sur téléphone sont désactivées. Le serveur a oublié les réglages et l'horaire.",
    "push.error": "Un problème est survenu : {message}",
    "push.demo": "La démo n'envoie jamais rien.",
    "push.alert.generic": "Une catégorie de budget est dépassée ce mois-ci.",
    "push.alert.titles": "{name} dépasse le budget ce mois-ci.",
    "push.alert.amounts": "{name} dépasse le budget ce mois-ci : {used} sur {budget}.",
    "nav.purchases": "Achats importants",
    "cat.purchases": "Achats importants",
    "notify.open.bills": "Événements",
    "notify.open.budgets": "Budgets",
    "notify.open.goals": "Achats importants",
    "notify.type.goals": "Achats importants",
    "notify.type.goals.hint": "un objectif qui manquera sa date, ou un objectif entièrement épargné",
    "notify.goalReady": "{name} est entièrement épargné ({amount}). Indiquez-le comme acheté une fois l'achat fait.",
    "notify.goalBehind": "{name} est en retard : au rythme actuel, il sera prêt le {projected} plutôt que le {target}.",
    "notify.goalStalled": "{name} ne reçoit rien ce mois-ci et ne sera donc pas prêt pour le {target}.",
    "notify.later": "Les notifications sur les dettes, les personnes et la sécurité s'ajouteront avec ces fonctionnalités.",
    "events.fromPurchase": "Ce paiement de prêt vient d'un achat important et se met à jour chaque fois que cet achat change. Pour le modifier, modifiez l'achat :",
    "budgets.purchasesLine": "Mis de côté pour les achats importants. Cette ligne reste verrouillée pour que les autres curseurs s'ajustent autour.",
    "budgets.purchasesOpen": "Modifier sur la page Achats importants",
    "budgets.allDollars": "Dollars ($)",
    "budgets.allPercent": "Pourcentage de l'enveloppe (%)",
    "budgets.unitSwitch": "Afficher {name} en pourcentage",
    "budgets.lockedDollars": "$ verrouillé",
    "budgets.lockedPercent": "% verrouillé",
    "budgets.fixedLock": "Retenu par vos objectifs d'achats importants",
    "budgets.typeAmount": "{name} {amount}, saisir un montant exact",
    "budgets.typeDollars": "Budget {name} en dollars",
    "budgets.typePercent": "Budget {name} en pourcentage",
    "budgets.subsToggle": "Sous-catégories de {name} ({count})",
    "budgets.goalsToggle": "Objectifs de {name} ({count})",
    "budgets.goals": "Objectifs sous {name}",
    "budgets.noGoals": "Aucune épargne en cours pour l'instant.",
    "budgets.goalShare": "{amount} ce mois-ci",
    "budgets.goalBy": "d'ici le {date}",
    "nav.groups": "Groupes",
    "cat.fronted": "Avancé pour des groupes",
    "groups.intro": "Suivez l'argent que vous avancez pour d'autres, comme un forfait cellulaire partagé ou un voyage, et récupérez-le. Les groupes restent privés : personne n'est averti ni inscrit.",
    "groups.list": "Vos groupes",
    "groups.none": "Aucun groupe pour l'instant. Créez-en un ci-dessous.",
    "groups.new": "Nouveau groupe",
    "groups.name": "Nom du groupe",
    "groups.namePlaceholder": "Forfait cellulaire familial",
    "groups.people": "Autres personnes",
    "groups.peopleHelp": "Noms séparés par des virgules, par exemple : Sam, Jo, Kim. Vous êtes ajouté automatiquement.",
    "groups.create": "Créer le groupe",
    "groups.created": "{name} créé.",
    "groups.you": "Vous",
    "groups.owedShort": "On vous doit : {amount}",
    "groups.oweShort": "Vous devez {amount}",
    "groups.settled": "Tout est réglé",
    "groups.balances": "Qui doit quoi",
    "groups.owesYou": "{name} vous doit {amount}",
    "groups.youOwe": "Vous devez {amount} à {name}",
    "groups.isSettled": "{name} est à jour",
    "groups.markPaid": "Marquer comme payé",
    "groups.paidRecorded": "{amount} de {name} enregistré.",
    "groups.between": "Entre les autres",
    "groups.pays": "{from} paie {amount} à {to}",
    "groups.reminder": "Rappel pour {name}",
    "groups.reminderLabel": "Message de rappel pour {name}",
    "groups.reminderHello": "Bonjour {name}, pour {group} tu me dois {amount} :",
    "groups.reminderThanks": "Merci!",
    "groups.reminderHint": "Copiez-le dans un texto ou un courriel. {app} ne l'envoie jamais à votre place.",
    "groups.copy": "Copier le message",
    "groups.copied": "Copié.",
    "groups.addExpense": "Ajouter une dépense",
    "groups.addExpenseButton": "Ajouter la dépense",
    "groups.what": "Quoi",
    "groups.amount": "Montant",
    "groups.date": "Date",
    "groups.paidBy": "Payé par",
    "groups.repeat": "Répétition",
    "groups.once": "Une fois",
    "groups.split": "Partage",
    "groups.split.equal": "À parts égales",
    "groups.split.shares": "Par parts",
    "groups.split.percent": "En pourcentage",
    "groups.split.exact": "Montants exacts",
    "groups.part.shares": "Parts de {name}",
    "groups.part.percent": "Pourcentage de {name}",
    "groups.part.exact": "Montant de {name}",
    "groups.link": "Payé avec",
    "groups.linkNone": "Non lié à une transaction",
    "groups.linkHelp": "Lier le paiement retire la part des autres de vos propres dépenses.",
    "groups.recurringHelp": "Chaque échéance est associée automatiquement à votre paiement, et la part des autres est retirée de vos propres dépenses.",
    "groups.err.amount": "Indiquez à quoi ça correspond et un montant.",
    "groups.err.nobody": "Choisissez au moins une personne avec qui partager.",
    "groups.err.percent": "Les pourcentages doivent totaliser 100.",
    "groups.err.exact": "Les montants doivent totaliser {amount}.",
    "groups.expenseAdded": "{name} ajouté, {amount}.",
    "groups.expenses": "Dépenses",
    "groups.noExpenses": "Aucune dépense pour l'instant.",
    "groups.yourShare": "Votre part",
    "groups.actions": "Actions",
    "groups.repeats": "récurrent",
    "groups.linked": "lié",
    "groups.delete": "Supprimer",
    "groups.deleteExpense": "Supprimer {name}",
    "groups.confirmDeleteExpense": "Supprimer « {name} »?",
    "groups.recurring": "Factures récurrentes",
    "groups.recurringLine": "{name}, {amount}, {repeat} à partir du {from}",
    "groups.ended": "terminé le {date}",
    "groups.stop": "Arrêter la répétition",
    "groups.stopped": "{name} ne se répète plus après aujourd'hui.",
    "groups.payments": "Remboursements",
    "groups.paymentLine": "{from} a payé {amount} à {to} le {date}",
    "groups.undo": "Annuler",
    "groups.undoPaymentLabel": "Annuler {amount} de {from}",
    "groups.members": "Personnes",
    "groups.addMember": "Ajouter une personne",
    "groups.add": "Ajouter",
    "groups.remove": "Retirer",
    "groups.removeMember": "Retirer {name}",
    "groups.deleteGroup": "Supprimer ce groupe",
    "groups.confirmDelete": "Supprimer « {name} » et toutes ses dépenses et remboursements?",
    "groups.deleted": "{name} supprimé.",
    "groups.offers": "Remboursements à vérifier",
    "groups.offer": "{name} vous a envoyé {amount} le {date}. L'enregistrer comme remboursement pour {group}?",
    "groups.offerYes": "Enregistrer le remboursement",
    "groups.offerNo": "Ce n'est pas un remboursement",
    "groups.dashOwed": "On vous doit {amount} dans vos groupes.",
    "groups.dashOpen": "Ouvrir Groupes",
    "groups.paidYou": "{from} vous a payé {amount} le {date}",
    "groups.youPaid": "Vous avez payé {amount} à {to} le {date}",
    "groups.youPaidRecorded": "{amount} payé à {name} enregistré.",
    "groups.showAll": "Tout afficher ({count})",
    "groups.showFewer": "Afficher moins",
    "purchases.intro": "Indiquez ce que vous voulez acheter, son prix et quand. Épargner met de l'argent de côté chaque mois sur une ligne de budget verrouillée. Financer ajoute le paiement du prêt à votre calendrier et à votre budget à partir de la date d'achat.",
    "purchases.setAside": "Mettre de côté chaque mois",
    "purchases.auto": "Ce dont vos objectifs ont besoin : {amount} ce mois-ci",
    "purchases.autoOn": "Suit ce dont vos objectifs ont besoin.",
    "purchases.fixed": "Un montant fixe (partagé entre les objectifs, par ordre de priorité)",
    "purchases.fixedAmount": "Montant par mois",
    "purchases.line": "La ligne de budget Achats importants contient {amount} ce mois-ci.",
    "purchases.openBudgets": "Voir les budgets",
    "purchases.noRoom": "Seulement {fit} sur {wanted} entre dans le budget, car le reste est verrouillé ou à 0 $. Les objectifs moins prioritaires prendront plus de temps.",
    "purchases.short": "Vos objectifs ont besoin de {need} par mois pour respecter leurs dates; les moins prioritaires seront donc repoussés.",
    "purchases.saving": "Épargne en cours",
    "purchases.noSaves": "Aucune épargne en cours. Ajoutez-en une ci-dessous.",
    "purchases.priorityHelp": "Classés par priorité. Quand l'argent manque, les objectifs en haut de la liste passent en premier.",
    "purchases.target": "{price} d'ici le {date}",
    "purchases.progressLabel": "Épargné pour {name}",
    "purchases.progress": "{saved} épargnés sur {price} ({percent})",
    "purchases.monthly": "Besoin de {need} par mois; reçoit {funded} ce mois-ci.",
    "purchases.projected": "À ce rythme, prêt le {date}.",
    "purchases.never": "À ce rythme, il ne sera pas prêt.",
    "purchases.pace.complete": "Entièrement épargné",
    "purchases.pace.ahead": "En avance",
    "purchases.pace.on-track": "Dans les temps",
    "purchases.pace.behind": "En retard",
    "purchases.pace.overdue": "Date dépassée",
    "purchases.addSaved": "Ajouter à l'épargne",
    "purchases.addSavedLabel": "Montant à ajouter à l'épargne pour {name}",
    "purchases.added": "{amount} ajoutés à {name}.",
    "purchases.edit": "Modifier {name}",
    "purchases.editShort": "Modifier",
    "purchases.moveUp": "Monter {name} dans les priorités",
    "purchases.moveUpShort": "Monter",
    "purchases.moveDown": "Descendre {name} dans les priorités",
    "purchases.moveDownShort": "Descendre",
    "purchases.markBought": "Indiquer comme acheté",
    "purchases.markedBought": "{name} indiqué comme acheté. Il ne prend plus d'argent dans le budget.",
    "purchases.delete": "Supprimer {name}",
    "purchases.confirmDelete": "Supprimer {name}?",
    "purchases.confirmDeleteLoan": "Supprimer {name} et ses paiements de prêt du calendrier?",
    "purchases.deleted": "{name} supprimé.",
    "purchases.financed": "Financés",
    "purchases.financeSummary": "{price}, mise de fonds de {down}, acheté le {date}",
    "purchases.payment": "{amount} par mois pendant {count} mois, à partir du {first}",
    "purchases.interest": "Intérêts totaux de {interest}; coût total de {total}, remboursé d'ici le {last}.",
    "purchases.made": "{made} paiements faits sur {count}.",
    "purchases.financeBudget": "Le paiement figure dans votre calendrier d'événements et compte dans sa catégorie de budget jusqu'à ce que chaque paiement apparaisse dans vos transactions.",
    "purchases.bought": "Achetés",
    "purchases.boughtItem": "{name}, {price}, acheté le {date}",
    "purchases.add": "Ajouter un achat important",
    "purchases.editTitle": "Modifier {name}",
    "purchases.name": "De quoi s'agit-il?",
    "purchases.price": "Prix",
    "purchases.date": "Quand l'acheter",
    "purchases.mode": "Comment allez-vous payer?",
    "purchases.mode.save": "Épargner pour l'acheter",
    "purchases.mode.finance": "Le financer",
    "purchases.savedSoFar": "Déjà épargné",
    "purchases.down": "Mise de fonds",
    "purchases.rate": "Taux d'intérêt (% par année)",
    "purchases.term": "Durée du prêt",
    "purchases.termMonths": "{count} mois",
    "purchases.category": "Catégorie de budget pour les paiements",
    "purchases.categoryHint": "Pour un véhicule, Transport › Paiement de prêt ou de location. Sans catégorie, les paiements comptent dans Autre.",
    "purchases.previewSave": "Cela représente {amount} par mois à partir de maintenant.",
    "purchases.previewFinance": "Cela représente {amount} par mois pendant {count} mois, avec {interest} d'intérêts.",
    "purchases.addButton": "Ajouter l'achat",
    "purchases.saved": "{name} enregistré.",
    "purchases.paymentTitle": "Paiement de prêt : {name}",
    "purchases.err.name": "Donnez-lui un nom.",
    "purchases.err.price": "Entrez un prix supérieur à 0 $.",
    "purchases.err.date": "Choisissez une date.",
    "purchases.err.saved": "Entrez le montant en chiffres, ou laissez vide.",
    "purchases.err.rate": "Entrez un taux entre 0 et 40 %.",
};
//# sourceMappingURL=fr.js.map